
export const publicationsData = [
  {
    id: 1,
    title: "Forest dynamics and climate change adaptation strategies",
    authors: "Dr. Marie Dubois, Prof. Jean Martin",
    journal: "Forest Ecology and Management",
    date: "2024-01-15",
    abstract: "Cette étude examine l'adaptation des écosystèmes forestiers face aux changements climatiques et propose des stratégies de gestion durable...",
    tags: ["Adaptations", "Biodiversité", "Formation"],
    pdfUrl: "/sample-publication.pdf",
    doi: "10.1016/j.foreco.2024.01.001"
  },
  {
    id: 2,
    title: "Sustainable silviculture practices in European forests",
    authors: "Dr. Pierre Leroy, Dr. Sophie Bernard",
    journal: "European Journal of Forest Research",
    date: "2023-12-10",
    abstract: "Une analyse comparative des pratiques sylvicoles durables dans différents contextes européens, avec un focus sur l'innovation et les nouvelles approches...",
    tags: ["Sylviculture", "Concepts", "Gouvernance"],
    pdfUrl: "/sample-publication.pdf",
    doi: "10.1007/s10342-2023-12345"
  },
  {
    id: 3,
    title: "Biodiversity conservation in managed forests",
    authors: "Dr. Claire Vincent, Prof. Michel Rousseau",
    journal: "Conservation Biology",
    date: "2023-11-22",
    abstract: "Cette recherche explore les stratégies de conservation de la biodiversité dans les forêts gérées, en analysant l'impact des différentes pratiques de gestion...",
    tags: ["Biodiversité", "Biologie", "Laboratoire vivant"],
    pdfUrl: "/sample-publication.pdf",
    doi: "10.1111/cobi.14123"
  },
  {
    id: 4,
    title: "Carbon sequestration in temperate forests",
    authors: "Dr. François Moreau, Dr. Anne Petit",
    journal: "Global Change Biology",
    date: "2023-10-05",
    abstract: "Étude approfondie du stockage de carbone dans les forêts tempérées européennes et son rôle dans l'atténuation du changement climatique...",
    tags: ["Carbone", "Modélisation", "Prospective"],
    pdfUrl: "/sample-publication.pdf",
    doi: "10.1111/gcb.16789"
  },
  {
    id: 5,
    title: "Forest bioeconomy and sustainable development",
    authors: "Dr. Isabelle Garnier, Prof. Luc Durand",
    journal: "Forest Policy and Economics",
    date: "2023-09-18",
    abstract: "Analyse des opportunités et défis de la bioéconomie forestière dans le contexte du développement durable...",
    tags: ["Bioéconomie", "SHS", "Histoire"],
    pdfUrl: "/sample-publication.pdf",
    doi: "10.1016/j.forpol.2023.09.001"
  },
  {
    id: 6,
    title: "Art and forest conservation awareness",
    authors: "Dr. Camille Artois, Prof. Henri Bois",
    journal: "Environmental Communication",
    date: "2023-08-30",
    abstract: "Exploration du rôle de l'art dans la sensibilisation à la conservation des forêts et l'engagement du public...",
    tags: ["Art", "STS", "Mousses"],
    pdfUrl: "/sample-publication.pdf",
    doi: "10.1080/17524032.2023.2234567"
  }
];
